import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { cssMainSelector } from "../../lib/cssSelectors";
import { lighten } from "polished";

const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${p => p.theme.spacing.md};
  }
`;

const Title = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    font-weight: ${p => p.theme.font.weightBold};
    padding-bottom: ${p => p.theme.spacing.md};
  }
`;

const selectContainerPadding = css `padding: ${p => p.theme.spacing.xs} ${p => p.theme.spacing.sm}`;
const SelectContainer = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    select {
      background-color: ${p => p.theme.color.white};
      border-color: ${p => lighten(0.6, p.theme.color.darkSlateBlue)};
      border-radius: ${p => p.theme.generic.borderRadius};
      box-shadow: 0 1px 3px 0 ${p => lighten(0.5, p.theme.color.darkSlateBlue)};
      border-style: solid;
      border-width: 1px;
      color: ${p => p.theme.filter.selectFilter.textColor};
      font-family: ${p => p.theme.font.family};
      font-size: ${p => p.theme.font.size};
      font-weight: ${p => p.theme.font.weightBold};
      height: 30px;
      outline: 0;
      ${selectContainerPadding};
      width: 100%;
    }
  }
`;

class SelectFilter extends PureComponent {
  render() {
    const { blankText, onChange, title, withBlank } = this.props;

    return (
      <Container>
        <Title>{title}</Title>
        <SelectContainer>
          <select onChange={onChange} value={this.selectValue()}>
            {withBlank && <option value="">{blankText}</option>}
            {this.selectOptions()}
          </select>
        </SelectContainer>
      </Container>
    );
  }

  selectValue() {
    const { value } = this.props;

    if (value == null) {
      return "";
    } else {
      return value;
    }
  }

  selectOptions() {
    const { values } = this.props;
    const options = [];

    for (const [optionValue, optionText] of values) {
      options.push(
        <option value={optionValue} key={optionValue}>
          {optionText}
        </option>
      );
    }

    return options;
  }
}

SelectFilter.propTypes = {
  blankText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  values: PropTypes.array.isRequired,
  withBlank: PropTypes.bool
};

SelectFilter.defaultProps = {
  withBlank: true
};

export default SelectFilter;
